import React, { FunctionComponent } from 'react';
import * as ioTs from 'io-ts';
import { useClasses } from 'app/utils/css';
import Badge from 'app/components/uknow/ui/Badge';
import { GREY_F, GREY_S, WHITE_A } from 'app/constants/Colors';
import { useI18n } from 'app/components/localization';
import AlertBox, { AlertVariant } from 'app/components/presentation/alert/AlertBox';
import FlexMarginGroup from 'app/components/layout/FlexMarginGroup';
import { List } from 'immutable';

export const SentenceAttributes = ioTs.strict({
  text: ioTs.string,
  translation: ioTs.string,
  note: ioTs.union([ioTs.string, ioTs.undefined]),
});

type SentenceProps = ioTs.TypeOf<typeof SentenceAttributes>;

const Sentence: FunctionComponent<SentenceProps> = ({
  text,
  translation,
  note,
}) => {
  const classes = useClasses({
    text: {
      fontWeight: 600,
    },
    translation: {
      color: GREY_S,
    },
    content: {
      padding: '15px',
    },
  });
  return (
    <div className={classes.content} data-testid="uknow-sentence">
      <FlexMarginGroup vertical margin="15px">
        {note &&
          // Since the note is shown as auxiliary information and not time critical do not set an alert role.
          <AlertBox variant={AlertVariant.Info}>{note}</AlertBox>}
        <FlexMarginGroup vertical margin="5px">
          <span className={classes.text}>{text}</span>
          <span className={classes.translation}>{translation}</span>
        </FlexMarginGroup>
      </FlexMarginGroup>
    </div>
  );
};

interface IProps {
  sentences: List<SentenceProps>;
}

const SentencesContainer: FunctionComponent<IProps> = ({
  sentences,
}) => {
  const { t } = useI18n();
  const classes = useClasses({
    exampleSentence: {
      background: WHITE_A,
      margin: '15px 0',
    },
  });
  return (
    sentences.isEmpty() ? null : (
      <div className={classes.exampleSentence} data-testid="uknow-sentence-group">
        <Badge color={GREY_F}>{t('uknow.answer.sentence.badge')}</Badge>
        {sentences.map((props, idx) => <Sentence {...props} key={idx} />)}
      </div>
    )
  );
};

export default SentencesContainer;
